
import FiltroComparativo from "./FiltroComparativo.vue";

export default {
  name: "VendasComparativo",
  components: { FiltroComparativo },

  props: {
    /**
     * Aceita:
     *  - { data: { series: [{name, data}], categories: [] } }
     *  - ou flat: { series: [...], categories: [...] }
     */
    dados: {
      type: Object,
      default: () => ({ data: { series: [], categories: [] } }),
    },
    loading: { type: Boolean, default: false },
    ignoreInitialApply: { type: Boolean, default: true },
  },

  data() {
    return {
      chartKey: 0, // força redesenho do apex quando dados mudam
    };
  },

  computed: {
    categories() {
      return this.dados?.categories ?? this.dados?.data?.categories ?? [];
    },
    chartSeries() {
      const s = this.dados?.series ?? this.dados?.data?.series;
      return Array.isArray(s)
        ? s.map((it) => ({
            name: it?.name ?? "",
            data: Array.isArray(it?.data) ? it.data : [],
          }))
        : [];
    },
    chartOptions() {
      return {
        chart: { type: "line", toolbar: { show: false } },
        stroke: { curve: "smooth", width: 3 },
        markers: { size: 4 },
        colors: ["#1E90FF", "#A9A9A9", "#2ECC71", "#E67E22"],
        xaxis: { categories: this.categories, tickPlacement: "on" },
        yaxis: {
          labels: {
            formatter: (val) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 0,
              }).format(val || 0),
          },
        },
        tooltip: {
          y: {
            formatter: (val) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(val || 0),
          },
        },
        legend: { show: true },
      };
    },
  },

  watch: {
    // quando os dados mudarem (ex.: novo filtro), força redesenho
    dados: {
      deep: true,
      handler() {
        this.chartKey++;
      },
    },
  },

  methods: {
    // reemite SEMPRE pro pai buscar no back
    onChangeComparacao(payload) {
      // payload: { modeId, label, a:{inicio,fim}, b:{inicio,fim} }
      this.$emit("change-comparacao", payload);
    },
  },
};
